import {
    ArticleExperiencePhotosState,
    initialArticleExperiencePhotosState,
} from "@/mk2/apps/wiki/containers/ArticleExperiencePhoto/ArticleExperiencePhoto.reducers";
import { AppState } from "@/mk2/reducers";

export const geArticleExperiencePhotosState = (
    state: AppState,
    categorySlug: string,
    articleSlug: string,
): ArticleExperiencePhotosState =>
    state.containers.wiki.articlesExperiencePhotos[`${categorySlug}/${articleSlug}`] ||
    initialArticleExperiencePhotosState;
